import React from 'react'


const h1Styles = {fontSize: 45 + 'px', marginLeft: '100px', marginRight: '100px', marginTop: '100px', marginBottom: '0', paddingBottom: '0', letterSpacing: '5px', textAlign: 'center'}
const linkStyles = {fill: 'purple', backgroundColor: "white", fontSize: '40', fontFamily: 'Montserrat Alternates, sans-serif', textDecoration: 'none'}
const textStyles = { fontFamily: 'Montserrat Alternates, sans-serif', textAlign: 'left', marginLeft: '300px'}
const pStyles = {marginLeft:'230px', marginRight:'230px', marginTop:'100px', fontSize: '25px', fontFamily: 'Montserrat Alternates, sans-serif', textAlign: 'left'}
const liStyles = {marginLeft:'230px', marginRight:'230px', fontSize: '25px', fontFamily: 'Montserrat Alternates, sans-serif'}
const itemsStyles = {margin:'10px', fontSize: '25px', fontFamily: 'Montserrat Alternates, sans-serif', textAlign: 'left'}



const GetLucky3000 = () => {

    return (
        <div style={{width: '1000px', zoom: '0.5', textAlign: 'center', margin: '0 auto', position: 'relative'}}>
            
            <h1 style={h1Styles}>Get Lucky 3000</h1>

            <h2 style={textStyles}>JavaScript</h2>

            <div style={textStyles}>
            <a style={linkStyles} href='https://github.com/theandrewfulton/getlucky3000'>check out Github rep</a>
            </div>

            <p style={pStyles}>A two day hackacthon with made with two fine Coder Academy class mates, Nathan Blaga and Andrew Fulton</p>
                <br></br>

                <p style={pStyles}>Online dating is a confusing and exhausting experience. So why not at least take out the work of trying to make the perfect profile 
                    when there's an application that can do it for you? Anyone who has been on an online dating service knows 
                    that the perfect profile needs:
                </p>
                <ul style={liStyles}>
                    <li style={itemsStyles}>A Dad Joke</li>
                    <li style={itemsStyles}>A Dog pic (duh)</li>
                    <li style={itemsStyles}>A way to make your job sound more impressive than it really is</li>
                    <li style={itemsStyles}>Some goofy words of affirmation</li>
                </ul>

                <p style={pStyles}>This app provides these
                </p>
            


                {/* <div style={backStyles}>
                <Link style={backStyles} to="/">
                    BACK
                </Link>
                </div> */}
        </div>
    )
}

export default GetLucky3000